import { BuxDocumentCloudy } from "@bux/document/cloudy.mts";

class DocumentPublic extends BuxDocumentCloudy {
    constructor() {
        super();
    }
}

new DocumentPublic();

//
import "./DocumentPublic.mcss";
